import React from 'react';
import './datepicker.scss';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { IconButton } from '@material-ui/core';
import { CalendarOutlinedIcon } from 'components/icons/calendar-outlined';
import { AppConstants } from 'constants/app-constants.enum';
import { DatepickerProps } from './datepicker-props';

export const Datepicker: React.FC<DatepickerProps> = (props) => {
  const {
    value = null, // Marked as required in Material UI DatePicker
    emptyLabel = 'Select date',
    autoOk = true,
    variant = 'inline',
    format = AppConstants.CalendarDateFormat,
    disableToolbar = true,
    disabled,
    readOnly,
    InputProps,
    InputLabelProps,
    PopoverProps,
    onChange = () => { }, // Marked as required in Material UI DatePicker
    ...rest
  } = props;

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <DatePicker
        {...rest}
        className={`sg-datepicker ${readOnly ? 'sg-datepicker--readonly' : ''}`}
        value={value}
        emptyLabel={emptyLabel}
        autoOk={autoOk}
        variant={variant}
        format={format}
        disableToolbar={disableToolbar}
        disabled={disabled}
        readOnly={readOnly}
        InputProps={{
          ...InputProps,
          readOnly,
          endAdornment: !readOnly && <IconButton color="secondary" disabled={disabled}><CalendarOutlinedIcon color="primary" /></IconButton>,
        }}
        InputLabelProps={{
          ...InputLabelProps,
          shrink: true,
        }}
        PopoverProps={{
          ...PopoverProps,
          className: 'sg-datepicker-popover',
        }}
        onChange={onChange}
      />
    </MuiPickersUtilsProvider>
  );
};
